/* eslint-disable no-new */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import vip from './vip_store'
// import navbar_user from './navbar_user'
import prepare_product from './prepare_store'
import products from './products_store'
import dialog from './dialog_store'
import saved_order from './saved_orders_store'
import select_options from './select_options_store'
import shop_info from './shop_store'
import sys_user from './sys_user'

export default new Vuex.Store({
  modules: {
    vip,
    prepare_product,
    products,
    dialog,
    saved_order,
    select_options,
    shop_info,
    sys_user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js